<template>
  <div class="flex h-full flex-row">
    <div
      class="bg-surface rounded-t-small md:rounded-extra-large relative flex h-full grow flex-col overflow-y-auto md:overflow-y-scroll"
    >
      <div
        v-if="showTopBar"
        class="bg-surface sticky top-0 z-30 flex shrink-0 flex-row items-center px-5 pt-5"
        :class="[!smallBottomPadding && 'pb-5', smallBottomPadding && 'pb-1']"
      >
        <slot name="top-bar" :toggle-sheet="toggleSheet" :show-sheet="showSheet" />
      </div>
      <div
        class="@container/content h-full w-full px-4 pb-8"
        :class="[!fullWidth && 'mx-auto max-w-5xl']"
      >
        <slot :toggle-sheet="toggleSheet" :show-sheet="showSheet" />
      </div>
    </div>
    <div
      class="fixed top-0 right-0 z-60 h-full shrink-0 overflow-hidden transition-all duration-400 lg:relative"
      :class="[
        sheetBelowMd && 'md:hidden',
        showSheet && 'ease-fast-effect w-[272px] lg:w-[336px]',
        !showSheet && 'ease-fast-effect w-0',
      ]"
    >
      <div
        class="bg-surface lg:rounded-extra-large ml-4 h-full w-[256px] rounded-l-2xl lg:w-[320px]"
      >
        <div
          class="ease-fast-effect flex flex-col transition-opacity delay-100 duration-500"
          :class="[showSheet && 'opacity-100', !showSheet && 'opacity-0']"
        >
          <div v-if="sideBarTitle" class="flex flex-row p-6">
            <h3 class="text-on-surface-variant text-title-large grow pr-3">
              {{ sideBarTitle }}
            </h3>
            <BaseIconButton class="-m-2" icon="close" @click="toggleSheet" />
          </div>
          <slot name="side-bar" :toggle-sheet="toggleSheet"> </slot>
        </div>
      </div>
    </div>
  </div>
  <BaseScrim
    v-if="showSheet"
    class="z-50"
    :class="sheetBelowMd ? 'md:hidden' : 'lg:hidden'"
    @click="toggleSheet"
  />
</template>
<script lang="ts" setup>
  import { computed, ref, useSlots, watch } from 'vue'
  import { useMediaQuery } from '@vueuse/core'
  import BaseIconButton from '../base/button/icon-button/BaseIconButton.vue'
  import BaseScrim from '../base/dialog/BaseScrim.vue'

  interface Props {
    fullWidth?: boolean
    sideBarTitle?: string
    smallBottomPadding?: boolean
    sheetBelowMd?: boolean
  }

  const props = defineProps<Props>()

  const slots = useSlots()

  const showTopBar = computed(() => !!slots['top-bar'])

  const showSheet = ref(false)
  const isMd = useMediaQuery('(min-width: 768px)')

  const toggleSheet = () => (showSheet.value = !showSheet.value)

  watch(isMd, (matches) => {
    if (props.sheetBelowMd && matches) {
      showSheet.value = false
    }
  })
</script>
